import { ERRORS } from '@/common/constants/errors';
import { TMarket } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';

export const useMarket = () => {
  const { company } = useEmployeeDetails();

  const marketMatch = <T extends TMarket>(
    ...markets: [T, ...T[]]
  ): T | false => {
    return marketMatches({
      market: company.market.slug,
      markets,
    });
  };

  const marketMatchStrict = <T extends TMarket>(
    ...markets: [T, ...T[]]
  ): T | never => {
    return marketMatchesStrict({
      market: company.market.slug,
      markets,
    });
  };

  return { ...company.market, marketMatch, marketMatchStrict };
};

export const marketMatches = <T extends TMarket>({
  market,
  markets,
}: {
  market: TMarket;
  markets: [T, ...T[]];
}): T | false => {
  return markets.includes(market as T) ? (market as T) : false;
};

export const marketMatchesStrict = <T extends TMarket>({
  market,
  markets,
}: {
  market: TMarket;
  markets: [T, ...T[]];
}): T | never => {
  const slug = marketMatches({ market, markets });
  if (!slug) {
    throw new Error(ERRORS.MARKET_NOT_SUPPORTED);
  }
  return slug;
};
